<template>
  <h3 class="pb5">Rapport de regroupement par intervenant (CDX_0086)</h3>
  <CritereRechercheRegroupement ref="critereRechercheRegroupement"
                                :entiteDefault="entiteDefault" :siteDefault="siteDefault"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from "vuex";
import CritereRechercheRegroupement from "@/components/rapports/Rechercher/CritereRechercheRegroupement.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";

export default {
  name: "RegroupementIntervenant",
  components: {CritereRechercheRegroupement, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Regroupement");
    this.isRechercheDataLoading = true;

    this.$store.dispatch("dossier/obtenirSiteEntiteAction")
        .then((res) => {
          this.entiteDefault = res.data.entite;
          this.siteDefault = res.data.site;

          this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
              .then((res) => {
                this.assignerResultat(res);
                this.isRechercheDataLoading = false;
              });
        });
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },

  data() {
    return {
      isRechercheDataLoading: false,
      entiteDefault: null,
      siteDefault: null,
    }
  },

  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheRegroupement.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheRegroupement.getCritereRecherche();
      criteresRapportVO.titre = "regroupementIntervenant";
      criteresRapportVO.nomRapport = "regroupement.RegroupementIntervenant";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRapportVO)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>